import { fromJS, Map } from 'immutable';
import { isSSR } from 'src/helpers/ssr';

import {
  LOG_IN,
  LOG_OUT,
  SIGN_UP,
  SET_CLIENT_INFO,
  SHOW_AUTH_POPUP,
  HIDE_AUTH_POPUP,
  SHOW_LOGOUT_POPUP,
  HIDE_LOGOUT_POPUP,
  SET_CLIENT_AUTH_TOKEN,
  SET_CLIENT_CONFIRM_PHONE,
  SET_CLIENT_BONUS_SCORE,
} from './constants';

const initialState =
  !isSSR && window?.current_client ? fromJS(window.current_client) : Map();

export default function clientReducer(state = initialState, action) {
  switch (action.type) {
    case LOG_IN:
    case SIGN_UP: {
      const {
        id,
        email,
        avatar,
        unconfirmed_email,
        confirmed_at,
        unconfirmed_phone,
        name,
        surname,
        phone,
        bonus_score,
        coefficient_for_room_upgrade,
        has_password,
        auth_token,
        name_en,
        surname_en,
      } = action.payload;

      return state.merge({
        id,
        email,
        phone,
        avatar,
        unconfirmed_email,
        unconfirmed_phone,
        confirmed_at,
        name,
        surname,
        bonus_score,
        coefficient_for_room_upgrade,
        has_password,
        authToken: auth_token,
        surname_en,
        name_en,
      });
    }
    case SET_CLIENT_INFO: {
      const {
        id,
        email,
        name,
        surname,
        phone,
        unconfirmed_email,
        confirmed_at,
        unconfirmed_phone,
        bonus_score,
        coefficient_for_room_upgrade,
        auth_token,
        surname_en,
        name_en,
      } = action.payload;

      return state.merge({
        id,
        email,
        name,
        surname,
        phone,
        bonus_score,
        unconfirmed_email,
        confirmed_at,
        unconfirmed_phone,
        coefficient_for_room_upgrade,
        authToken: auth_token,
        surname_en,
        name_en,
      });
    }
    case SET_CLIENT_BONUS_SCORE: {
      const { bonus_score } = action.payload;

      return state.merge({
        bonus_score,
      });
    }
    case SET_CLIENT_CONFIRM_PHONE: {
      const { confirmedPhone } = action.payload;

      return state.merge({ phone: confirmedPhone, unconfirmed_phone: null });
    }
    /**
     * Сохраняет дополнительные данные о клиенте после авторизации
     * или обновляет данные пользователя на чекауте
     */
    case LOG_OUT: {
      return Map();
    }
    case SET_CLIENT_AUTH_TOKEN: {
      return state.set('authToken', action.payload);
    }
    case SHOW_AUTH_POPUP: {
      return state.set('showAuthPopup', true);
    }
    case HIDE_AUTH_POPUP: {
      return state.set('showAuthPopup', false);
    }
    case SHOW_LOGOUT_POPUP: {
      return state.set('showLogOutPopup', true);
    }
    case HIDE_LOGOUT_POPUP: {
      return state.set('showLogOutPopup', false);
    }
    default:
      return state;
  }
}
